/**
 * `useTheme` hook split out of `ThemeContext.tsx` so the provider file
 * exports only React components (keeps Vite/HMR + fast-refresh happy).
 *
 * UI-v2 Phase 0: no-op shim returns `brand: "certain"` alongside the
 * existing preference/effective defaults so the extended ThemeContextValue
 * shape is fully satisfied outside a ThemeProvider.
 */
import { useContext } from "react";
import { ThemeContext } from "./themeContextValue";

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    if (typeof console !== "undefined") {
      console.warn(
        "useTheme called outside ThemeProvider; returning a no-op shim.",
      );
    }
    return {
      preference: "dark" as const,
      effective: "dark" as const,
      setPreference: () => {},
      brand: "certain" as const,
    };
  }
  return ctx;
}
